<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="80%"
    @close="handleClose"
  >
    <!-- 查询条件 -->
    <el-card class="box-card">
      <el-form
        ref="queryForm"
        :model="queryForm"
        label-width="100px"
        class="query-section"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="终端编号：">
              <el-input
                v-model="queryForm.posSnStart"
                placeholder="请输入入库SN"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截止SN：">
              <el-input
                v-model="queryForm.posSnEnd"
                placeholder="请输入截止SN"
                clearable
              />
            </el-form-item>
          </el-col>
          <!-- 结果统计 -->

          <el-col :span="12">
            <el-form-item>
              <span class="count-section">共{{ tableData.length }}件</span>
              <el-button type="primary" @click="handleQuery">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card
      class="box-card"
      v-if="['hq_allocate', 'branch_allocate'].includes(actionType)"
    >
      <el-form
        ref="formData"
        :model="formData"
        label-width="100px"
        class="query-section"
      >
        <el-row :gutter="20">
          <!-- 总公司批量下拨 -->
          <el-col :span="6" v-if="actionType === 'hq_allocate'">
            <el-form-item label="分公司：">
              <el-select
                v-model="formData.groupId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in groupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 分公司批量下拨 -->
          <el-col :span="6" v-if="actionType === 'branch_allocate'">
            <el-form-item label="业务员：">
              <el-select
                v-model="formData.salesId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in salesList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      stripe
      border
      height="400"
      style="width: 100%"
    >
      <el-table-column prop="posSn" label="终端号" />
      <el-table-column prop="platfromName" label="平台名称" />

      <el-table-column
        prop="groupName"
        label="分公司"
        v-if="actionType === 'branch_callback'"
      />
      <el-table-column
        prop="salesName"
        label="业务员"
        v-if="actionType === 'branch_callback'"
      />

      <el-table-column prop="amountType" label="终端类型" />
    </el-table>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" :disabled="submitLoading">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="submitLoading">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getTerminalOperationList,
  getGroupListToTerminal,
  getUserListByLogin,
  allocateBatch,
  callbackBatch,
} from "@/api/erp/terminal";

export default {
  name: "AllocateDialog",
  props: {},
  data() {
    return {
      dialogTitle: "",
      actionType: "", // 操作类型：hq_allocate(总部批量下拨)、branch_allocate(分公司下拨下拨)、branch_callback(分公司回拨)
      visible: false,
      queryForm: {
        posSnStart: "",
        posSnEnd: "",
        operationType: "", // required 操作类型：0(总部下拨)、1(分公司下拨/回拨)
      },
      formData: {
        groupId: "", // 分公司ID
        salesId: "", // 业务员ID
        salesName: "", // 业务员名称
      },
      tableData: [],
      loading: false,
      submitLoading: false,
      groupList: [],
      salesList: [],
    };
  },
  watch: {
    'formData.salesId'(val) {
      // 当选择业务员时，自动获取并存储业务员名称
      if (val) {
        const selectedSales = this.salesList.find(item => item.id === val);
        this.formData.salesName = selectedSales ? selectedSales.name : '';
      } else {
        // 清除业务员时，也清除业务员名称
        this.formData.salesName = '';
      }
    }
  },
  methods: {
    open(config = {}) {
      this.visible = true;
      this.actionType = config.actionType || "";
      console.log("actionType:", this.actionType);
      if (this.actionType === "hq_allocate") {
        this.queryForm.operationType = 0; // 总部下拨
        this.dialogTitle = "总部批量下拨";
        this.getGroupList();
      } else if (this.actionType === "branch_allocate") {
        this.queryForm.operationType = 1; // 分公司下拨
        this.dialogTitle = "分公司批量下拨";
        this.getUserList();
      } else if (this.actionType === "branch_callback") {
        this.queryForm.operationType = 1; // 分公司回拨
        this.dialogTitle = "分公司批量回拨";
      }
      this.handleQuery();
    },
    // 获取分公司列表
    async getGroupList() {
      try {
        const { data } = await getGroupListToTerminal();
        this.groupList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.groupList = [];
      }
    },
    // 获取业务员列表
    async getUserList() {
      try {
        const { data } = await getUserListByLogin();
        this.salesList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.salesList = [];
      }
    },
    // 查询终端
    handleQuery() {
      this.fetchTerminalList();
    },
    // 重置表单
    handleReset() {
      this.$refs.queryForm.resetFields();
      this.tableData = [];
    },
    // 获取终端列表
    async fetchTerminalList() {
      this.loading = true;
      const param = {
        posSnStart: this.queryForm.posSnStart,
        posSnEnd: this.queryForm.posSnEnd,
        operationType: this.queryForm.operationType,
      };
      try {
        const { data } = await getTerminalOperationList(param);
        this.tableData = data || [];
        this.loading = false;
      } catch (error) {
        this.$message.error("获取终端列表异常");
        this.tableData = [];
        this.loading = false;
      }
    },

    // 确认选择
    async handleConfirm() {
      if (this.submitLoading) {
        return;
      }
      if (this.tableData.length === 0) {
        this.$message.warning("请先查询终端数据");
        return;
      }
      if (this.actionType === "hq_allocate" && !this.formData.groupId) {
        this.$message.warning("请选择分公司");
        return;
      }
      if (this.actionType === "branch_allocate" && !this.formData.salesId) {
        this.$message.warning("请选择业务员");
        return;
      }

      this.submitLoading = true;
      let formData = {};
      let api = null;

      // 总部批量下拨
      if (this.actionType === "hq_allocate") {
        formData = {
          operationType: this.queryForm.operationType,
          groupId: this.formData.groupId,
          terminalIds: this.tableData.map((item) => item.id),
        };
        api = allocateBatch;
      }

      // 分公司批量下拨
      if (this.actionType === "branch_allocate") {
        formData = {
          operationType: this.queryForm.operationType,
          salesId: this.formData.salesId,
          salesName: this.formData.salesName,
          terminalIds: this.tableData.map((item) => item.id),
        };
        api = allocateBatch;
      }

      // 分公司批量回拨
      if (this.actionType === "branch_callback") {
        formData = {
          operationType: this.queryForm.operationType,
          terminalIds: this.tableData.map((item) => item.id),
        };
        api = callbackBatch;
      }

      try {
        await api(formData);
        this.$message.success("操作成功");
        this.$emit("success");
        this.handleClose();
      } catch (error) {
        this.$message.error("操作失败");
      } finally {
        this.submitLoading = false;
      }
    },
    // 关闭对话框
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 5px;
}
</style>
